import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { GbDashboardAuctionsDataAccessSelectedAuctionModule } from 'libs/gb-dashboard/auctions/data-access-selected-auction/src/lib/gb-dashboard-auctions-data-access-selected-auction.module'
import * as fromProjectorContainers from './+state/projector-containers.reducer'
import { ProjectorContainersEffects } from './+state/projector-containers.effects'
import { ProjectorContainersFacade } from './+state/projector-containers.facade'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromProjectorContainers.PROJECTOR_CONTAINERS_FEATURE_KEY,
      fromProjectorContainers.projectorContainersReducer,
    ),
    EffectsModule.forFeature([ProjectorContainersEffects]),
    GbDashboardAuctionsDataAccessSelectedAuctionModule,
  ],
  providers: [ProjectorContainersFacade],
})
export class GbDashboardPresenterDataAccessProjectorContainersModule {}
